import React, { Component } from "react";
import axios from "axios";
import Dropzone from "react-dropzone";
import Attach from "../../resources/icons/Attach.jsx";
import CloudUpload from "../../resources/icons/CloudUpload.jsx";
import CheckmarkSharp from "../../resources/icons/CheckmarkSharp.jsx";
import Send from "../../resources/icons/Send.jsx";

class MsgPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      chatId: props.chatId,
      sending: false,
      mute: false,
      attachment: { file_name: "", uuid: "", attached: false },
      fileProgress: null,
      dropZoneOpened: false,
      percentsLoad: 0,
      loading: false,
      bad_mime: false,
      allowed_mime: props.allowed_mime,
      allowed_mime_list: "",
    };
    this.msgRef = React.createRef();
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.toggleDropZone = this.toggleDropZone.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      chatId: nextProps.chatId,
      allowed_mime: nextProps.allowed_mime,
      allowed_mime_list: nextProps.allowed_mime
        ? Object.keys(nextProps.allowed_mime)
            .sort((a, b) => a - b)
            .join(", ")
        : "",
    };
  }
  componentWillUnmount() {
    return {
      dropZoneOpened: false,
    };
  }
  _handleKeyDown(e) {
    if (e.keyCode === 13 && e.shiftKey) {
    } else if (e.keyCode === 13) {
      e.preventDefault();
      this.sendMessage();
    }
  }
  toggleDropZone() {
    this.setState({
      dropZoneOpened: !this.state.dropZoneOpened,
      bad_mime: false,
      attachment: { file_name: "", uuid: "", attached: false },
    });
  }

  getFiles(files) {
    let rxExt = /^.+\.([^\.]+)$/;
    let ext = rxExt.exec(files[0].name);
    //console.log(this.state.allowed_mime[ext]);
    if (ext) {
      if (!this.props.allowed_mime[ext[1].toLowerCase()]) {
        console.log(ext[1]);
        this.setState({
          bad_mime: true,
          attachment: { file_name: "", uuid: "", attached: false },
        });
        return;
      }
    }
    this.toggleDropZone();
    axios
      .request({
        method: "post",
        url:
          this.props.mentorChatApiRoot +
          "/file/upload?token=" +
          localStorage.getItem("mentor_chat_token") +
          "&file_name=" +
          encodeURIComponent(files[0].name),
        data: files[0],
        onUploadProgress: (p) => {
          this.setState({
            percentsLoad: (p.loaded / p.total) * 100,
            loading: true,
            mute: true,
            attachment: {
              file_name: files[0].name,
              uuid: "",
              attached: true,
            },
          });
        },
      })
      .then((data) => {
        this.setState({
          percentsLoad: 0,
          loading: false,
          mute: false,
          attachment: {
            file_name: data.data.file_name,
            uuid: data.data.uuid,
            attached: true,
          },
        });
      });
  }

  sendMessage() {
    if (
      this.msgRef.current &&
      (this.msgRef.current.innerText.length > 0 ||
        this.state.attachment.attached) &&
      !this.state.sending
    ) {
      this.state.sending = true;
      this.setState({ mute: true });
      fetch(this.props.mentorChatApiRoot + "/message/send", {
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("mentor_chat_token"),
          chat_id: this.state.chatId,
          text: this.msgRef.current.innerText,
          attachment: this.state.attachment,
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.ok) {
              this.msgRef.current.innerText = "";
            }
            this.state.sending = false;
            this.setState({
              mute: false,
              attachment: { file_name: "", uuid: "", attached: false },
              percentsLoad: 0,
              loading: false,
              dropZoneOpened: false,
            });
          },
          // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
          // чтобы не перехватывать исключения из ошибок в самих компонентах.
          (error) => {
            console.log(error);
            this.setState({
              error,
            });
            this.state.sending = false;
            this.setState({ mute: false });
          },
        );
    }
  }
  render() {
    const { text, dropZoneOpened, bad_mime, allowed_mime, allowed_mime_list } =
      this.state;
    return (
      <div
        className="MentorChatMsgPanel"
        style={this.state.mute ? { pointerEvents: "none", opacity: "0.6" } : {}}
      >
        <div className="ChatAttachmentButton" onClick={this.toggleDropZone}>
          <Attach color="#707070" height="50px" width="50px" />
        </div>
        {dropZoneOpened ? (
          <Dropzone onDrop={(acceptedFiles) => this.getFiles(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()} className="FileDropZone">
                  <input {...getInputProps()} />
                  Перетащите файл в данную область <br />
                  <div>
                    <CloudUpload color="#707070" height="65px" width="65px" />
                  </div>
                  {bad_mime ? (
                    <span style={{ color: "#f00" }}>
                      не допустимый тип файла, можно отправлять только документы
                      и изображения следующих типов:
                      <br />
                      {allowed_mime_list}
                    </span>
                  ) : (
                    <>
                      или нажмите на нее для открытия <br />
                      диалога выбора файла.
                    </>
                  )}
                </div>
              </section>
            )}
          </Dropzone>
        ) : this.state.attachment.attached ? (
          <div className="FileLoadingContainer">
            <div className="FileLoadingContainerInfo">
              {!this.state.loading ? (
                <CheckmarkSharp color="#707070" height="20px" width="20px" />
              ) : (
                ""
              )}
              <span>{this.state.attachment.file_name} </span>
            </div>
            {this.state.loading ? (
              <div className="FileProgressContainer">
                <div
                  className="Progress"
                  style={{ width: this.state.percentsLoad + "%" }}
                ></div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <div className="ChatInputPanel">
          <span
            ref={this.msgRef}
            className="ChatInputMessage"
            role="textbox"
            contentEditable=""
            onKeyDown={this._handleKeyDown}
          ></span>
        </div>
        <div className="ChatSendMsgButton" onClick={this.sendMessage}>
          <Send color="#f9c623" height="40px" width="40px" />
          <div className="FileUploadPanel"></div>
        </div>
      </div>
    );
  }
}

export default MsgPanel;
